import { Sidebar } from 'common/components/sidebar/Sidebar.tsx'
import { menuTabs } from '@/components/sidebar/sidebarTabsAgency.tsx'

export const SidebarAgency = (props: any) => <Sidebar {...props} mode={props.mode} agency menuTabs={menuTabs}/>